import {Team, TeamState, ReportingTeamState} from "@irati/types"

export default function teamName(team?: Team) {
  if (team?.teamState === TeamState.BillingUnit || team?.teamState === ReportingTeamState.BillingUnit) {
    return team.teamName.replace("platform.billingUnit.", "")
  } else if (team) {
    return team.teamName
  }

  return "Unknown Team"
}
